export enum NumericUnit {
  Default = "INT",
  Euro = "EUR",
}
